import type { VersionSide } from './ConfigVersionDiffView'

// One row of GET /api/fleet/sites/:siteId/site-config/history. Unlike device
// config there is no separate "active" row — the newest history row IS the
// current version — so this is a straight map + sort, no active/history merge.
export interface SiteConfigHistoryRow {
  readonly configVersion: number
  readonly configJson: Record<string, unknown>
  readonly updatedBy: string
  readonly updatedByName: string | null
  readonly updatedAt: string | null
}

export function buildSiteConfigVersionEntries(history: ReadonlyArray<SiteConfigHistoryRow>): VersionSide[] {
  return history
    .map((h) => ({
      version: h.configVersion,
      config: h.configJson,
      // pushedFrom is the diff view's "who" slot (rendered as "via {x}");
      // site config has no change-reason column, so changeReason is always null.
      meta: {
        changedAt: h.updatedAt,
        pushedFrom: h.updatedByName ?? h.updatedBy,
        changeReason: null,
      },
    }))
    .sort((a, b) => b.version - a.version)
}
